import type { FeatureFlagKey } from '@sb/feathers-types';
import type { StepKind } from '@sb/routine-runner';

/**
 * Shared source of truth for Weld permitted child step kinds. Mirrors the
 * UI behavior but is exported from the validation library so both UI and
 * server can consume the same rule.
 */
export function getPermittedChildStepKindsShared(
  featureFlags: Partial<Record<FeatureFlagKey, boolean>> = {},
): readonly StepKind[] {
  const permittedSteps: StepKind[] = ['Waypoint'];

  if (!featureFlags.disableArcStepInWeld) {
    permittedSteps.push('Arc');
  }

  return permittedSteps;
}
